import { useMemo, useState } from "react";

export const useProductSlice = () => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);

  return useMemo(() => ({ selectedProducts, setSelectedProducts, selectedProductIds, setSelectedProductIds }), [selectedProducts, selectedProductIds]);
};
